/**
 * Types for the internal admin token wallet endpoints.
 * The API speaks snake_case; the app uses camelCase (converted via snakeToCamel).
 */

/** Raw shape returned by `GET/POST /tokens/wallet`. */
export interface WalletServerResponse {
  id: number;
  brand_id: number;
  wallet_type: string;
  balance: number;
  monthly_allotment: number;
  rollover_cap: number;
  plan_name: string;
}

/** App-facing wallet shape. */
export interface TokenWallet {
  id: number;
  brandId: number;
  walletType: string;
  balance: number;
  monthlyAllotment: number;
  rolloverCap: number;
  planName: string;
}

export type AdjustmentType = "balance_topup" | "balance_deduction" | "set_monthly_allotment" | "set_rollover_cap";

/** Wallet types a brand can hold (one row per type). */
export type WalletType = "generation_tokens" | "studio_credits";

export const WALLET_TYPES: { value: WalletType; label: string }[] = [
  { value: "generation_tokens", label: "Generation Tokens" },
  { value: "studio_credits", label: "Studio Credits" }
];

/** Body for `POST /tokens/wallet`. */
export interface CreateWalletRequest {
  brand_id: number;
  plan_name: string;
  monthly_allotment: number;
  rollover_cap: number;
  initial_balance: number;
  wallet_type: WalletType;
}

/** Body for `POST /tokens/adjust`. `amount` is always a non-negative magnitude. */
export interface AdjustTokensRequest {
  brand_id: number;
  adjustment_type: AdjustmentType;
  amount: number;
  reason: string;
  /** Stable per submit so a retry is applied at most once. */
  idempotency_key: string;
  wallet_type: WalletType;
}

export interface AdjustTokensResponse {
  transaction_id: number;
  wallet: WalletServerResponse;
}
